<template>
  <!-- <v-app v-scroll="onScroll"> -->
  <v-app ref="main-app">

    <Header
      class="app-header"
    ></Header>

    <!-- App Content -->
    <v-content
      app
      class="app-content"
    >
      <v-container
        class="app-container"
      >
        <router-view/>
        <!-- App Footer -->
        <Footer></Footer>
        <!-- <div style="position: fixed; top:50%; left:50%; z-index:9999; color: red;">
          <h1>{{ offsetTop }}</h1>
        </div> -->

      </v-container>
    </v-content>
    <!-- <transition name="fade">
      <Loader :isVisible="isLoading"></Loader>
    </transition> -->
  </v-app>
</template>

<script>
import axios from 'axios'
import Header from '@/components/app/header/Header'
import Footer from '@/components/app/footer/Footer'
import Loader from '@/components/app/Loader'

export default {
  name: 'App',

  data () {
    return {
      isLoading: false,
      axiosInterceptor: null
      // offsetTop: 0
    }
  },

  // async created () {
  //   if (!this.$store.getters['auth/isAuthenticated']) this.$store.dispatch('auth/authLogout')
  //   await axios.interceptors.response.use(undefined, (error) => {
  //     return new Promise((resolve, reject) => {
  //       if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
  //         // if we ever get an unauthorized, logout the user
  //         this.$store.dispatch('auth/authLogout')
  //       }
  //       throw error
  //     })
  //   })

  //   // // Check if the first visit user onboarding
  //   // if (this.$store.state.auth.onboarding) {
  //   //   console.log(this.$store.state.auth.onboarding)
      
  //   // }
  // },

  // async mounted () {
  //   this.disableInterceptor()
  //   await this.$nextTick(() => {
  //     this.enableInterceptor()
  //     // The whole view is rendered, so I can safely access or query
  //     // the DOM. ¯\_(ツ)_/¯
  //   })
  // },

  methods: {
    enableInterceptor() {
      this.axiosInterceptor = axios.interceptors.request.use((config) => {
        this.isLoading = true
        return config
      }, (error) => {
        this.isLoading = false  
        return Promise.reject(error)
      })

      axios.interceptors.response.use((response) => {
        this.isLoading = false    
        return response
      }, function(error) {
        this.isLoading = false
        return Promise.reject(error)
      })
    },
    disableInterceptor() {
      axios.interceptors.request.eject(this.axiosInterceptor)
    }

    // onScroll (e) {
    //   // this.offsetTop = e.target.scrollTop
    //   this.offsetTop = window.pageYOffset || document.documentElement.scrollTop
    // }
  },

  components: {
    Header: Header,
    Footer: Footer,
    Loader: Loader
  }
}
</script>
